var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 15.8333V13.4999H10.832V15.8333H0.332031ZM0.332031 6.49993V4.1666H10.832V6.49993H0.332031ZM14.7987 19.3333L13.1654 17.6999L16.1987 14.6666L13.1654 11.6333L14.7987 9.99993L17.832 13.0333L20.8654 9.99993L22.4987 11.6333L19.4654 14.6666L22.4987 17.6999L20.8654 19.3333L17.832 16.2999L14.7987 19.3333ZM17.307 8.83327L13.1654 4.6916L14.7987 3.05827L17.2779 5.53743L22.2362 0.579102L23.8695 2.2416L17.307 8.83327Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRule);
export default __webpack_public_path__ + "static/media/icon_rule.71f9e64677438a97347a8da0f5654cb4.svg";
export { ForwardRef as ReactComponent };